<div class="block comment text-center">

    <form [formGroup]="feedbackForm" (submit)="guardarfeedback()">
        <h4>¿Te ayudó la información?</h4>

        <input id="toggle-on" formControlName="esLike" name="esLike" value="1" type="radio" (click)="guardarSiNo($event.target)" [attr.disabled]="feedbackcompleto? true : null">
        <label for="toggle-on" class="btn btn-outline-success">Sí <i class="far fa-thumbs-up"></i></label>
        <input id="toggle-off" formControlName="esLike" name="esLike" value="0" type="radio" (click)="guardarSiNo($event.target)" [attr.disabled]="feedbackcompleto? true : null">
        <label for="toggle-off" class="btn btn-outline-danger">No <i class="far fa-thumbs-down"></i></label>

        <div class="alert alert-danger" role="alert" *ngIf="feedbackNoValido">
            La valoración es requerida.
        </div>
        <div class="form-group mb-30" *ngIf="ConValoracion && !feedbackcompleto">
            <h6 for="message">¿Como podemos mejorar?</h6>
            <textarea class="form-control comentario" formControlName="comentario" [class.form-control-danger]="comentarioNoValido" id="comentario" rows="5" style="height: max-content;" placeholder="Escribí tu mensaje"></textarea>
            <div class="alert alert-danger" role="alert" *ngIf="comentarioNoValido">
                <p *ngIf="feedbackForm.get('comentario').hasError('required')">Para poder enviar, dejá tu comentario.</p>
                <p *ngIf="feedbackForm.get('comentario').hasError('maxLength')">El comentario ingresado es muy largo (superaste los 350 Caracteres).</p>
            </div>
            <input type="hidden" name="respuestaId" formControlName="respuestaId" />
            <button class="btn btn-primary w-25" type="submit" [ngClass]="{'loading':isLoading}" (click)="setSaving($event.target)">Enviar</button>
        </div>
        <div class="alert alert-success" role="alert" *ngIf="feedbackcompleto">
          ¡Muchas gracias! Tu opinión nos ayuda a mejorar.
        </div>
    </form>
</div>
